<template>
    <div class="well ovx-auto">
        <div class="flex-level">
            <div class="flex fs-4 bold">
                {{ $l10n.__('Services liés par le time tracking') }}
            </div>
            <div class="flex aright">
                <CompassButton
                    :label="$t.__('common.actions.impact_profit')"
                    type="secondary"
                    :disabled="impactButtonIsDisable"
                    @click="impact()"
                />
                <CompassButton
                    :label="$t.__('documents.overview.tab.margin.TimeTracking.quick_entry')"
                    type="secondary"
                    :disabled="!canImpact"
                    :onclick="`TimetrackingEntry.addFromDoc('${doctype}', ${docid});`"
                />
            </div>
        </div>

        <el-table
            ref="multipleTable"
            class="table-margin"
            :data="timetrackings"
            @selection-change="handleSelectionChange"
        >
            <el-table-column type="selection" :selectable="canProcess" property="processMargin">
            </el-table-column>
            <el-table-column :label="$t.__('common.labels.impact_profit')">
                <template #default="scope">
                    {{ displaySaasBoolean(scope.row.processMargin) }}
                </template>
            </el-table-column>
            <el-table-column :label="$t.__('common.labels.date')">
                <template #default="scope">
                    {{ $filters.saasDateFormatted(scope.row.date) }}
                </template>
            </el-table-column>
            <el-table-column property="staff" :label="$t.__('common.labels.staff')">
            </el-table-column>
            <el-table-column
                property="service"
                :label="$t.__('documents.overview.tab.margin.TimeTracking.service')"
            >
            </el-table-column>
            <el-table-column
                :label="
                    $t.__('documents.overview.tab.margin.TimeTracking.hourly_cost_excluding_tax')
                "
            >
                <template #default="scope">
                    {{ $filters.numberFormatCurrency(scope.row.cost) }}
                </template>
            </el-table-column>
            <el-table-column
                property="time"
                :label="$t.__('documents.overview.tab.margin.TimeTracking.declared_time')"
            >
            </el-table-column>
            <el-table-column
                :label="
                    $t.__('documents.overview.tab.margin.TimeTracking.total_cost_excluding_tax')
                "
            >
                <template #default="scope">
                    {{ $filters.numberFormatCurrency(scope.row.totalAmount) }}
                </template>
            </el-table-column>
            <el-table-column v-if="canImpact" fixed="right">
                <template #default="scope">
                    <a class="link mr-2" @click="removeLink(scope.row, context)">
                        {{ $l10n.__('Délier') }}
                    </a>
                </template>
            </el-table-column>
        </el-table>
        <div v-if="timetrackings.length > 0" class="aright fs-3 mt-2">
            {{ $l10n.__('Total impact') }} : {{ $filters.numberFormatCurrency(formattedTotal) }}
        </div>
    </div>
</template>

<script>
import MarginMixins from './MarginMixins.js';
import { createNamespacedHelpers } from 'vuex';

const { mapState } = createNamespacedHelpers('documentOverview');

export default {
    mixins: [MarginMixins],
    data: function () {
        return {
            context: 'timetracking',
        };
    },
    computed: {
        ...mapState({
            timetrackings: (state) => state.timetrackings,
            original: (state) => state.timetrackings.filter((link) => link.processMargin === true),
        }),
    },
};
</script>
